import SearchLookup from '@bbc/news-vj-search-lookup'
import PostcodePlugin from '@bbc/news-vj-search-lookup-plugin-postcode';

const niData = require('../data/ni_data.json')
const enData = window.DataPres.getData('postcode-data') || {};
let lookupData;

if (Object.keys(enData).length > 0) lookupData = {...niData, ...enData};
else lookupData = niData;

export default class SearchManager {
  constructor () {
    this.lookup = new SearchLookup({
      target: document.getElementById('lookup-container'),
      data: lookupData,
      minChars: 2,
      vocab: {
        noResults: "Sorry, there's no election in this area, or the location wasn't recognised. Please try another postcode or council name.",
      },
      clearInput: true,
      onSelect: (gssid, data) => {
        window.location.href = `http://${window.location.hostname}/news/topics/${data.url}`;
      },
      plugins: [new PostcodePlugin({
        searchType: 'gss-council',
        intersectCallback: (postcode) => PostcodePlugin.isFullPostcode(postcode)
    })],
    })
  }
}

